import { observer } from "mobx-react-lite"
import { store } from "../../../stores/Store"
import { TypeIcon } from "../../../misc/Icons"
import { Button, MenuItem, MenuList } from "@mui/material"
import { AlertModal } from "../../..";
import { AccountCreateForm, NewSponsorClientAccountForm } from "../../form/admin/AccountForms";


interface ClientListProps {
    handleSelect: Function;
}


export default observer(function ClientList ({handleSelect}: ClientListProps) {

    const {accounts} = store.NodeStore
    var customers = accounts.filter(account => account.typeName === "Aora.Platform.Data.AccountNode" && account.accountType === "customer")
    var clients = accounts.filter(account => account.typeName === "Aora.Platform.Data.AccountNode" && account.accountType === "client")
    var sponsorClients = accounts.filter(account => account.typeName === "Aora.Nationality.Data.SponsorAccountNode")

    var clientLabel = store.NodeStore.getDisplayType({typeName: "Aora.Platform.Data.AccountNode"}, true)
    var sponsorLabel = store.NodeStore.getDisplayType({typeName: "Aora.Nationality.Data.SponsorAccountNode"}, true)

    return (
        <div style={{maxWidth: "700px"}}>
            {customers.map((customer, i) => {
                var customerClients = clients.filter((client) => client.parent?.uid === customer.uid)
                var customerSponsorClients = sponsorClients.filter((client) => client.parent?.uid === customer.uid)
                return (
                    <div key={i}>
                        {store.AppStore.checkJwtRole("sysuser") ? (
                            <MenuItem key={i} style={{padding: "4px 4px"}} onClick={() => handleSelect(customer.uid)}>
                                <TypeIcon node={customer} style={{fontSize: "18px", marginRight: "6px"}} />
                                <span>{customer.label}</span>
                            </MenuItem>
                        ) : null}

                        {customerClients?.length || customerSponsorClients?.length ? (
                            <div style={{margin: "5px 0 20px 0", display: "grid", gap: "20px"}}>
                                <AccountListGroup groupHeader={sponsorLabel} accounts={customerSponsorClients} handleSelect={handleSelect} />
                                <AccountListGroup groupHeader={clientLabel} accounts={customerClients} handleSelect={handleSelect} />
                            </div>
                        ) : (
                            <div className="tool-section" style={{margin: "5px 0 20px 0"}}>
                                <div className="tool-table">
                                    <small style={{color: "#adadad"}}>{customer.label} hasn't got any clients yet.</small>
                                </div>
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
})


function AccountListGroup ({groupHeader, accounts, handleSelect}) {

    if (!accounts?.length) return <></>

    return (
        <div className="tool-section">
            <div className="tool-table">
                <small style={{color: "#adadad"}}>{groupHeader}</small>

                <MenuList>
                    {accounts.map((account, i) => (
                        <MenuItem key={i} style={{paddingLeft: 0}} onClick={() => handleSelect(account.uid)}>
                            <TypeIcon node={account} style={{fontSize: "18px", marginRight: "6px"}} />
                            <span>{account.label}</span>
                        </MenuItem>
                    ))}
                </MenuList>
            </div>
        </div>
    )
}